import { render, staticRenderFns } from "./rule-form-item.vue?vue&type=template&id=6a741320&scoped=true"
import script from "./rule-form-item.vue?vue&type=script&lang=ts"
export * from "./rule-form-item.vue?vue&type=script&lang=ts"
import style0 from "./rule-form-item.vue?vue&type=style&index=0&id=6a741320&prod&lang=scss&scoped=true"
import style1 from "./rule-form-item.vue?vue&type=style&index=1&id=6a741320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a741320",
  null
  
)

export default component.exports